import axios from 'axios';

export const baseURL = process.env.NODE_ENV == 'test' ? 'https://staging.deepidentify.ai/api' : '/api';

export const createAxiosInstance = async (id = null) => {
  
  const AXIOS_CONFIG = {
    baseURL,
    headers: {'Content-Type': 'application/json'},
    timeout: 60 * 60 * 1000
  };

  const instance = axios.create({
    ...AXIOS_CONFIG,
  });

  return instance;
};

export const validateApiResponse = (response) => {
  const statusSuccess = response.status === 200 || response.status === 201;
  const dataSuccess = response.data.success;

  console.log(statusSuccess);
  console.log(dataSuccess);
  return statusSuccess && dataSuccess;
}